
define(
	'Code25.Segments'
	, [
		"underscore", "jQuery", "Profile.Model", "Tools", "Utils", "Item.Model", "LiveOrder.Line.Model",'LiveOrder.Model'
	]
	, function (
		_, jQuery, ProfileModel, Tools, Utils, ItemModel, LiveOrderLineModel,LiveOrderModel
	) {
		'use strict';

		return {
			mount: function (container) {


				var profile = ProfileModel.getInstance();

				function getProfileSegments() {
					var contactRole = profile.get("contactRole");

					var contactName = (contactRole && contactRole.name) || "Unknown";

					var custentity_c25_item_segments_junior = Tools.getProfileValue("custentity_c25_item_segments_junior");
					var custentity_c25_item_segments = Tools.getProfileValue("custentity_c25_item_segments_admin");

					var segmentsList = [];

					try {
						if (contactName == "Junior") {
							custentity_c25_item_segments = custentity_c25_item_segments_junior;
						}

						if (custentity_c25_item_segments && custentity_c25_item_segments.indexOf(0, 1) == "[") {
							custentity_c25_item_segments = JSON.parse(Tools.getProfileValue("custentity_c25_item_segments_admin") || "[{\"value\":\"Every Customer\"}]");

							for (var i = 0; i < custentity_c25_item_segments.length; i++) {
								segmentsList.push(custentity_c25_item_segments[i].value)
							}
						} else {
							segmentsList = (custentity_c25_item_segments || "Every Customer").split("\u0005");
							var html = Tools.getProfileHtml("custentity_c25_item_segments_admin") || "data-options=\"[]\"";

							var start = html.indexOf("data-options=");
							var end = html.indexOf("]", start);

							if (end > start) {
								html = html.substring(start + 14, end + 1);

								html = html.split("&quot;").join("\"");
								html = html.split("&apos;").join("'");
								html = html.split("&amp;").join("&");
								html = html.split("&lt;").join("<");
								html = html.split("&gt;").join(">");
								var data = JSON.parse(html);


								for (var i = 0; i < segmentsList.length; i++) {
									for (var j = 0; j < data.length; j++) {

										if (segmentsList[i] == data[j].value) {
											segmentsList[i] = data[j].text;
											break;
										}
									}
								}


							}

						}
					} catch (err) {
						console.log(err);
					}
					return segmentsList;
				}

				_.extend(ProfileModel.prototype, {
					getSearchApiUrl: _.wrap(ProfileModel.prototype.getSearchApiUrl, function (getSearchApiUrl, options) {
						var res = getSearchApiUrl.apply(this, _.rest(arguments));

						var segmentsList = getProfileSegments();

						res = Utils.addParamsToUrl(
							res,
							{
								segments: segmentsList.join(",").split("-").join("~").split(" ").join("-")
							}
						);


						return res;
					})
				});


				var _isEdit = 0;
				function isEdit() {
					if (_isEdit == 0) {
						_isEdit = -1;
						try {
							_isEdit = window.self !== window.top ? 1 : -1;
							console.log("_isEdit", _isEdit);
						} catch (e) {
							console.error("in iFrame", e);
						}
					}
					return _isEdit == 1;
				}

				ItemModel.prototype.parse = function parse(response) {


					var single_item = response.items && response.items[0];

					if (single_item) {

						var segmentsList = getProfileSegments();

						var matrixchilditems_detail = single_item.matrixchilditems_detail;
						if (!matrixchilditems_detail) {
							matrixchilditems_detail = [single_item];
						}

						if (matrixchilditems_detail && matrixchilditems_detail.length > 0) {

							var custitem_c25_item_segments, found = false;
							for (var i = matrixchilditems_detail.length - 1; i >= 0; i--) {
								custitem_c25_item_segments = (matrixchilditems_detail[i].custitem_c25_item_segments || "").split(",");
								found = false;
								for (var j = 0; j < custitem_c25_item_segments.length; j++) {
									custitem_c25_item_segments[j] = custitem_c25_item_segments[j].trim();
									for (var k = 0; k < segmentsList.length; k++) {
										if (segmentsList[k] == custitem_c25_item_segments[j]) {
											found = true;
											break;
										}
									}
								}

								if (!found) {

									if (!isEdit()) {
										matrixchilditems_detail.splice(i, 1);
									}
								}
							}
							if (matrixchilditems_detail.length == 0) {
								single_item = null;
								response.items = [];
							}
						}

					}

					return single_item ? this.sanitize(single_item) : this.sanitize(response);
				}

				_.extend(LiveOrderLineModel.prototype, {

					initialize: _.wrap(LiveOrderLineModel.prototype.initialize, function (initialize) {
						var res = initialize.apply(this, _.rest(arguments));
						if (this.attributes) {
							var itemid = this.attributes.item.get("itemid");
							if (itemid) {
								if(isLineBlocked(this)){
									this.set("blocked",true);
								}
							}
						}
						return res;

					})
				});

				function isLineBlocked(model){
					if (model.attributes) {
							var itemid = model.attributes.item.get("itemid");
							if (itemid) {
								var custitem_c25_item_segments = model.attributes.item.get("custitem_c25_item_segments");

								var segmentsList = getProfileSegments();

								custitem_c25_item_segments = custitem_c25_item_segments.split(",");
								var found = false;
								for (var j = 0; j < custitem_c25_item_segments.length; j++) {
									custitem_c25_item_segments[j] = custitem_c25_item_segments[j].trim();
									for (var k = 0; k < segmentsList.length; k++) {
										if (segmentsList[k] == custitem_c25_item_segments[j]) {
											found = true;
											break;
										}
									}
								}
								if(!found){
									return true;
								}
							}
						}
						return false;
				}
				
				function isCartValid() {


					var order = LiveOrderModel.getInstance();

					var lines = order.get("lines"), model, item;
					let error = "";
					for (var i = 0; i < lines.length; i++) {
						model = lines.models[i];
						
						if (model.get("blocked")||isLineBlocked(model)) {
							item = model.get("item");
							error += "<b>" + item.get("itemid") + "</b> : " + item.get("_name") + "<br /><br />";
						}

					}
					
					if (error) {
						Tools.showErrorInModal(SC.Application, Utils.translate("Unable to Checkout"), Utils.translate("Please adjust your cart. Some items are not available in your account.") + "<br /><br />" + error);
						return false;
					}

					return true;
				}

				if (SC.ENVIRONMENT.SCTouchpoint == "shopping") {

					var CartSummaryView = require("Cart.Summary.View");
					CartSummaryView.prototype.events = CartSummaryView.prototype.events || {};
					CartSummaryView.prototype.events['click #btn-proceed-checkout'] = "checkoutButton";
					CartSummaryView.prototype.checkoutButton = function (e) {
						return isCartValid();
					}
					var HeaderMiniCartView = require("Header.MiniCart.View");
					HeaderMiniCartView.prototype.events = HeaderMiniCartView.prototype.events || {};
					HeaderMiniCartView.prototype.events['click .header-mini-cart-button-checkout'] = "checkoutButton";
					HeaderMiniCartView.prototype.checkoutButton = function (e) {
						return isCartValid();
					}
				}else if (SC.ENVIRONMENT.SCTouchpoint == "checkout") {

					var OrderWizardModuleSubmitButton = require('OrderWizard.Module.SubmitButton');
				if (OrderWizardModuleSubmitButton.OrderWizardModuleSubmitButton) {
					OrderWizardModuleSubmitButton = OrderWizardModuleSubmitButton.OrderWizardModuleSubmitButton;
				}
				
					_.extend(OrderWizardModuleSubmitButton.prototype, {

						isValid: _.wrap(OrderWizardModuleSubmitButton.prototype.isValid, function (isValid) {

							if (!isCartValid()) {
								return jQuery.Deferred().reject();
							}
							return isValid.apply(this, _.rest(arguments));
						})
					});
				}
			}
		};

	});
